import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { ProductDetailsContext } from '../context';
import { messages } from '../messages';

const EMPTY_PRODUCT_PROFILE_ID = '';

export const ProductDetailsPresetGroupDropdown = () => {
  const { userHasPermission, currentProductProfile, productProfiles, setCurrentProductProfile } = useContext(ProductDetailsContext);

  const text = currentProductProfile.name || <FormattedMessage {...messages.defaultPresetGroupText} />;
  const onProfileChange = (productProfileId) => {
    const profile = productProfiles.find((prof) => prof.productProfileId === productProfileId) || {};
    setCurrentProductProfile(profile);
  };

  return (
    <>
      <span>
        <FormattedMessage {...messages.presetGroupLabel} />
      </span>
      <DropdownMenu disabled={!userHasPermission} variant='form'>
        <DropdownMenuToggler>{text}</DropdownMenuToggler>
        <DropdownMenuItem id='default-option' onClick={() => setCurrentProductProfile(EMPTY_PRODUCT_PROFILE_ID)}>
          <FormattedMessage {...messages.none} />
        </DropdownMenuItem>
        {productProfiles.map(({ productProfileId, name }) => (
          <DropdownMenuItem key={productProfileId} onClick={() => onProfileChange(productProfileId)}>
            {name}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </>
  );
};
